<template>
  <div class="main">
    <el-row style="margin-top:12px;">
      <el-col :span="18">
        <SaleMonitor></SaleMonitor>
      </el-col>
      <el-col :span="6">
        <NewShare></NewShare>
      </el-col>
       </el-row>
 <el-row>
 <el-col :span="8" >
             <TimeToMarketLine></TimeToMarketLine>
      </el-col>
       <el-col :span="8">
        <SalesTrendMonitor></SalesTrendMonitor>
      </el-col>
       <el-col :span="8">   
          <NewEnergySalePre></NewEnergySalePre>
           
      </el-col>
   </el-row>
    <el-row>
      <el-col :span="8">
   <Sales4></Sales4>
      </el-col>
      <el-col :span="8"><NewEnergySaleMonitor></NewEnergySaleMonitor> 
      </el-col>
        <el-col :span="8">     <New4Quantity></New4Quantity>
        </el-col>
    </el-row>
    <el-row style="margin-top:12px;">
      <el-col :span="12">
      <BodyTypeSaleMonitor></BodyTypeSaleMonitor>
      </el-col>
      <el-col :span="12">
        <NewEnergyFactoryTop></NewEnergyFactoryTop>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">   </el-col>
      <el-col :span="12">  </el-col>
    </el-row>
  </div>
</template>
 
<script>
  import {
    mapMutations,
    mapGetters,
    mapActions,
    mapState
  } from "vuex";
  import NewEnergySaleMonitor from "@/components/charts/NewEnergySaleMonitor.vue";
  import BodyTypeSaleMonitor from "@/components/charts/BodyTypeSaleMonitor.vue";
  import NewEnergySalePre from "@/components/charts/NewEnergySalePre.vue";
  import NewEnergyFactoryTop from "@/components/charts/NewEnergyFactoryTop.vue"
  import SaleMonitor from "@/components/charts/SaleMonitor.vue"
  import NewShare from "@/components/charts/NewShare.vue"
  import NewEnergySaleTable from "@/components/charts/NewEnergySaleTable.vue"
  import SalesTrendMonitor from "@/components/charts/SalesTrendMonitor.vue"
  import Sales4 from "@/components/charts/Sales4.vue"
  import TimeToMarketLine from "@/components/charts/TimeToMarketLine.vue"
  import New4Quantity from "@/components/charts/New4Quantity.vue"
  export default {
    name: "home",
    components: {
      NewEnergySaleMonitor,
      BodyTypeSaleMonitor,
      NewEnergySalePre,
      NewEnergyFactoryTop,
      SaleMonitor,
      NewShare,
      NewEnergySaleTable,
      SalesTrendMonitor,
      Sales4,
      TimeToMarketLine,
      New4Quantity
    },
    data() {
      return {
      };
    },
    methods: {
    },
    computed: {
      ...mapState({
        isLoading: state => state.loadingCount > 0
      }),
    },
    mounted() {
    }
  };
</script>

